// The picker's body face, shared by the card and the pieces broken out of it. One definition, because
// a second copy is a second thing to update when brand re-issues the stack.
export const MADEFOR_TEXT = '"Wix Madefor Text", "Helvetica Neue", Arial, sans-serif';
